import { persistedQueryClient } from 'components/CacheableQueryClientProvider';
import { User } from './types';
import { canUserReport, isInternalUser } from './utils';

const SESSION_STORAGE_USE_NO_CACHE_HEADER_KEY = 'useNoCacheHeader';

export const getValueForNoCacheHeader = (user: User | null): boolean =>
  canUserReport(user) || isInternalUser(user);

export const setUseNoCacheHeader = (value: boolean): void => {
  sessionStorage.setItem(
    SESSION_STORAGE_USE_NO_CACHE_HEADER_KEY,
    String(value),
  );
};

export const shouldUseNoCacheHeader = (): boolean => {
  // use this value to decide if we should use the X-No-Cache header in our api calls
  const cachedValue = sessionStorage.getItem(
    SESSION_STORAGE_USE_NO_CACHE_HEADER_KEY,
  );

  if (cachedValue !== null) {
    return cachedValue === 'true';
  }

  const authUser =
    persistedQueryClient.getQueryData<User>(['auth-user']) ?? null;
  const value = getValueForNoCacheHeader(authUser);
  setUseNoCacheHeader(value);

  return value;
};
